import { render, staticRenderFns } from "./AssetsDepreciation.vue?vue&type=template&id=ef2297ae&scoped=true"
import script from "./AssetsDepreciation.vue?vue&type=script&lang=js"
export * from "./AssetsDepreciation.vue?vue&type=script&lang=js"
import style0 from "./AssetsDepreciation.vue?vue&type=style&index=0&id=ef2297ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2297ae",
  null
  
)

export default component.exports